import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useAlertContext } from "../context/Alerts";
import SimpleBar from 'simplebar-react';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url";
import { useJobDetailContext } from "../context/Job_details.js";
import { useQuery, useQueryClient, useInfiniteQuery } from "@tanstack/react-query";
import { useErrHandleContext } from "../context/Err_handle.js";

import {ThemeProvider, Container, Typography, Tabs, Tab, Chip, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Tooltip, Checkbox} from '@mui/material';
import {ThemeCustom} from '../styles/Theme';
import 'simplebar-react/dist/simplebar.min.css';
import 'filepond/dist/filepond.min.css';

import ButtonImgMain from "../components/button/Button_img_main";
import FooterBarReveiw from "../components/navbar/Footer_bar_review";
import Status from "../components/Status/Status_tag.js";
import ModalApplicantSummary from "../components/Modal/Modal_applicant_summary.js";
import ModalPdfView from "../components/Modal/Modal_pdf_view.js";
import SwitchInput from "../components/input/Switch_input.js";
import ModalRejectComment from "../components/Modal/Modal_reject_comment.js";
import ModalRejectCommentView from "../components/Modal/Modal_reject_comment_view.js";

import ExportLight from '../assets/export-light.svg';
import NotFound from '../assets/no-results-found.svg'
import TrashDark from '../assets/trash-dark.svg';
import CloseCircle from '../assets/close-circle-red.svg';
import TickCircle from '../assets/tick-circle-green.svg';
import Description from '../assets/message-text.svg';
import View from '../assets/eye.svg';
import Uncheck from '../assets/square.svg';
import Check from '../assets/tick-square.svg';
import ModalDelete from "../components/Modal/Modal_delete.js";
import Import from '../assets/import.svg'
import LoaderIcon from '../assets/loader.gif'
import emailShortlist from '../assets/email-shortlist.svg'
import emailReject from '../assets/email-reject.svg'
import emailPending from '../assets/email-pending.svg'
import EmailSent from '../assets/email-sent.svg'
import InforIcon from '../assets/InfoCircle.svg'

const Review = () => {

    const [value, setValue] = useState(0);
    const [files, setFiles] = useState([]);
    const [openSummary, setOpenSummary] = useState(false) 
    const [openPdfView, setOpenPdfView] = useState(false) 
    const [selectCheckbox, setSelectCheckbox] = useState([])
    const [openDelete, setOpenDelete] = useState(false) 
    const [delType, setDelType] = useState(1)
    const [deleteId, setDeleteId] = useState('')
    const [jobId, setJobId] = useState('')
    const [summaryDiscription, setSummaryDiscription] = useState('')
    const [summaryBreakdown, setSummaryBreakdown] = useState([])
    const [applicant, setApplicant] = useState({})
    const [rating, setRating] = useState('')
    const [cVLink, setCVLink] = useState('')
    const [cvProcess, setCvProcess] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [loader, setLoader] = useState(true)
    const [autoEmail, setAutoEmail] = useState(false);
    const [openRejectModal, setOpenRejectModal] = useState(false)
    const [rejectData, setRejectData] = useState({})
    const [openRejectViewModal, setOpenRejectViewModal] = useState(false)
    const { baseUrl } = useBaseUrlContext();
    const { jobStatus, jobName, jobRefId, autoEmailEnable} = useJobDetailContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const queryClient = useQueryClient()
    const location = useLocation();
    const navigate = useNavigate();
    const {handleError} = useErrHandleContext()

    //useEffect(()=>{console.log('file',files)},[files])
    useEffect(()=>{console.log('selectCheckbox',selectCheckbox)},[selectCheckbox])

    //get job id

    useEffect(()=>{
        const jobId = location.pathname.split('/').at(-1);
        console.log('jobId', jobId)
        setJobId(jobId)
    },[])

    //check auto email status

    useEffect(()=>{
        setAutoEmail(autoEmailEnable)
        console.log('user context ',  jobStatus, jobName, jobRefId, autoEmailEnable)
    },[autoEmailEnable])

    //get cv list

    const fetchCvData = async ({queryKey, pageParam = 0}) => {

        const [_key, value, jobId] = queryKey
        //console.log('queryKey > ', queryKey, pageParam)

        if(jobId){

            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
               
                const response = await axios.get(`${baseUrl}/cv?jobId=${jobId}&status=${value}&page=${pageParam}&size=10`, {headers:header})
                
                const res = response.data
                //console.log('res', response);
    
                if(res.code === 200){
                    //console.log('cvList', res.data)
                    setLoader(false)
                    return {
                        ...res.data,
                        nextCursor: res.data.lastPage ? null : pageParam + 1, 
                    };
                }
                else{
                    failAlert(true, res.message)
                    setLoader(false)
                    throw new Error(res.message)
                }

            } catch(error) {
                //failAlert(true, error.message)
                handleError(error)
                setLoader(false)
                return [];
            }

        } 
        else{
            return [];
        }   
        
    }

    //useQuery hook for get cv detail

    const {isLoading, data:cvList, fetchNextPage, isFetchingNextPage, hasNextPage} = useInfiniteQuery({

        queryKey: ['fetchCvData', value, jobId],
        queryFn: fetchCvData,
        cacheTime: 60 * 60 * 1000,
        refetchInterval: 5000,
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage?.nextCursor || null,

    })

    //query handle manually for get cv detail

    const fetchCvDataHandler = async () => {
        queryClient.invalidateQueries(['fetchCvData', value, jobId])
    }


    //submit shortlist multiple 

    const shortlist = () => {
        
        console.log('submitBtn')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const payload = selectCheckbox.map(id=>({
            cvId: id,
            status: "Shortlisted",
        }))

        const data = JSON.stringify({
            
            'cvStatusUpdates': payload
        })

        axios
        .put(`${baseUrl}/cv/updateStatusBulk`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('shortlist res', res.data)
                sucessAlert(true, res.message)
                setSelectAll(false)
                setSelectCheckbox([])

                if(autoEmail){
                    sendEmail(selectCheckbox, 'approve')
                }
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //submit shortlist single 

    const shortlistSingle = (id) => {
        
        console.log('submitBtn')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            cvId: id,
            status: "Shortlisted",
        })

        axios
        .put(`${baseUrl}/cv/updateStatus`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('shortlist res', res.data)
                sucessAlert(true, res.message)
                setSelectAll(false)
                setSelectCheckbox([])

                if(autoEmail){
                    const soloId = [id]
                    sendEmail(soloId, 'approve')
                }

                setOpenRejectModal()
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })


    }

    //open reject popup

    const openReject = (id, name, rate) => {
        setOpenRejectModal(true)
        setRejectData({'id':id, 'name':name, 'rate':rate})
    }

    //submit reject single

    const rejectSingle = (id, reason) => {

        console.log('reject')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            cvId: id,
            status: "Rejected",
            reason: reason
        })

        axios
        .put(`${baseUrl}/cv/updateStatus`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('reject res', res.data)
                sucessAlert(true, res.message)
                setSelectAll(false)
                setSelectCheckbox([])

                if(autoEmail){
                    const soloId = [id]
                    sendEmail(soloId, 'reject')
                }

                setOpenRejectModal(false)

            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

        
    }

    //submit reject 

    const reject = () => {

        console.log('reject')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const payload = selectCheckbox.map(id=>({
            cvId: id,
            status: "Shortlisted"
        }))

        const data = JSON.stringify({
            'cvStatusUpdates': payload
        })

        axios
        .put(`${baseUrl}/cv/updateStatusBulk`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('reject res', res.data)
                sucessAlert(true, res.message)
                setSelectAll(false)
                setSelectCheckbox([])

                if(autoEmail){
                    sendEmail(selectCheckbox, 'reject')
                }
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //reject reason preview

    const reasonPreview = (id, name, rate, reason) => {
        setRejectData({'id':id, 'name':name, 'rate':rate, 'reason':reason})
        setOpenRejectViewModal(true)
    }

    //send pending email

    const pendingEmail = (cvId) => {
        if(autoEmail){
            const soloId = [cvId]
            const emailAction = value === 1 ? 'approve' : 'reject'
            sendEmail(soloId, emailAction)
        }
    }

    //email send

    const sendEmail = (cvList, action) => {

        console.log('sendEmail', cvList, action)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'cvIdList': cvList
        })

        axios
        .post(`${baseUrl}/settings/sendMail/${action === 'reject'? 'Rejected' : 'Shortlisted'}`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('email', res.data)
                sucessAlert(true, res.message)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //remove all requirements

    const delAll = () => {
        setOpenDelete(true)
        setDelType(2)
    }

    //tab change

    const handleChange = (e, val) => {
        console.log('handleChange', val);
        setValue(val)
    }

    //delete func Multiple

    const delFuncMultiple = () => {

        console.log('this is delete', localStorage.getItem('token'))

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': selectCheckbox
        })

        axios
        .post(`${baseUrl}/cv/delete`, data,  {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('delete res', res.data)
                sucessAlert(true, res.message)
                setFiles([])        
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setOpenDelete(false)
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setOpenDelete(false)
        })

    }

    //delete func single

    const delFuncSingle = () => {

        console.log('this is delete', localStorage.getItem('token'))

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': [deleteId]
        })

        axios
        .post(`${baseUrl}/cv/delete`, data,  {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('delete res', res.data)
                sucessAlert(true, res.message)
                setFiles([])        
                fetchCvDataHandler()
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setOpenDelete(false)
            setDeleteId('')
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setOpenDelete(false)
            setDeleteId('')
        })

    }

    //Multiple download

    const download = () => {

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }

        const data = JSON.stringify({
            'idList': selectCheckbox
        })

        axios
        .post(`${baseUrl}/cv/download`, data, {headers:header, responseType:'arraybuffer'})
        .then((response) => {
            console.log('download multiple res', response.data)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${selectCheckbox.length}-files.zip`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //Download single

    const downloadSingle = (id, fileName) => {
        
        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json',
        }

        const data = JSON.stringify({
            'idList': [id]
        })

        axios
        .post(`${baseUrl}/cv/download`, data, {headers:header, responseType:'blob'})
        .then((response) => {

            console.log('download res', response.data)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //summary popup open

    const summary = (discription, applicantDetails, rating, sBreakdown)=>{
        console.log('summary', sBreakdown)
        setOpenSummary(true); 
        setSummaryDiscription(discription)
        setApplicant(applicantDetails)
        setRating(rating)
        setSummaryBreakdown(sBreakdown)
    }

    //Cv pdf viewer

    const viewResume = (pdf) => {
        setOpenPdfView(true)
        setCVLink(pdf)
        console.log('cv link', pdf)
    }

    //Checkbox select

    const isChecked = (checked, id, status) => {

        if(checked){
            setSelectCheckbox([...selectCheckbox, id])
        }
        else{
            const cvUnChecked = selectCheckbox.filter(select => select !== id)
            setSelectCheckbox(cvUnChecked)
        }

    }


    //select all

    const isCheckedAll = (checked) => {

        console.log('isCheckedAll', checked)

        if(checked){
            setSelectAll(true)
            const allSelect = cvList?.pages?.flatMap((cvContent, index) => {
                return cvContent.content.map((cv, i) => {
                    //console.log('cv***************2', cv)
                    if(cv.status === 'Pending' || cv.status === 'Shortlisted' || cv.status === 'Rejected'){
                        return cv.id;
                    }
                    return undefined;
                })
            }).filter(id => id !== undefined)

            //console.log('cv***************allSelect', allSelect)
            setSelectCheckbox(allSelect)

        }
        else{
            setSelectAll(false)
            setSelectCheckbox([])
        }
    }

    //select all change when selecting the indvidual checkboxes

    useEffect(()=>{

        if(selectCheckbox.length > 0){
            const allSelect = cvList?.pages?.flatMap((cvContent, index) => {
                return cvContent.content.map((cv, i) => {
                    //console.log('cv***************2', cv)
                    if(cv.status === 'Pending' || cv.status === 'Shortlisted' || cv.status === 'Rejected'){
                        return cv.id;
                    }
                    return undefined;
                })
            }).filter(id => id !== undefined)
            console.log('allSelect.length', allSelect.length, selectCheckbox.length)
            allSelect.length === selectCheckbox.length ? setSelectAll(true) : setSelectAll(false)
        }
        else{
            setSelectAll(false)
        }

    },[selectCheckbox])

    //remove selected value when tab change

    useEffect(()=>{

        setSelectAll(false)
        setSelectCheckbox([])

    },[value])

    //convert timestamp

    const covertTimestamp = (timestamp) => {

        if (!timestamp) return 'N/A';
        
        const date = new Date(JSON.parse(timestamp));

        if (isNaN(date)) return 'Invalid Date';

        const formattedDate = date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
      
        return formattedDate;

    }      

    //remove later

    useEffect(()=>{
        console.log('selectCheckbox > ', selectCheckbox)
    },[selectCheckbox])


    //auto email handling

    const autoEmailHandle = (state) => {
        console.log('state >', state)
        postAutoEmail(state)
        setAutoEmail(state)
    }

    //auto email API call

    const postAutoEmail = (autoEmail) => {

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'id': jobId,
            "mailAutomationEnabled": autoEmail
        })

        axios
        .put(`${baseUrl}/job-descriptions`, data,  {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('email status res', res.data)
                sucessAlert(true, res.message)
                sessionStorage.setItem("autoEmailEnable", res.data.mailAutomationEnabled)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
                setAutoEmail(false)
            }

        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setAutoEmail(false)
        })
    }

    // Handle infinite scrolling

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        //console.log('calc', scrollHeight - scrollTop ,'total', scrollHeight - scrollTop === clientHeight && hasNextPage && !isFetchingNextPage, 'clientHeight', clientHeight, 'scrollHeight', scrollHeight, 'scrollTop', scrollTop, 'hasNextPage', hasNextPage, 'isFetchingNextPage', isFetchingNextPage )
        if (scrollHeight - scrollTop <= (clientHeight + 5) && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
        }
    };


    return(
        <ThemeProvider theme={ThemeCustom}>
            <ModalApplicantSummary
                setOpenSummary={setOpenSummary}
                openSummary={openSummary}
                summaryDiscription={summaryDiscription}
                applicant={applicant}
                rating={rating}
                summaryBreakdown={summaryBreakdown}
            />
            <ModalPdfView
                setOpenPdfView={setOpenPdfView}
                openPdfView={openPdfView}
                cVLink={cVLink}
            />
            <ModalDelete
                setOpenDelete={setOpenDelete}
                openDelete={openDelete}
                delFuncMultiple={delFuncMultiple}
                delType={delType}
                selectedCount={selectCheckbox.length}
                delFuncSingle={delFuncSingle}
            />
            <ModalRejectComment
                setOpenRejectModal={setOpenRejectModal}
                openRejectModal={openRejectModal}
                rejectSingle={rejectSingle}
                rejectData={rejectData}
                autoEmail={autoEmail}
            />
            <ModalRejectCommentView
                setOpenRejectViewModal={setOpenRejectViewModal}
                openRejectViewModal={openRejectViewModal}
                rejectData={rejectData}
            />
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div>
                    <div className="mb-7 flex justify-between items-center">
                        <Typography variant="textheader2" component={'div'}>Review</Typography>
                        {jobStatus ? (
                            <ButtonImgMain 
                                variant='primary' 
                                type='button' 
                                disabled={false} 
                                name='Upload CVs'
                                class='capitalize'
                                img={ExportLight}
                                posision={'right'}
                                onClick={()=>navigate(`/upload-cv/${jobId}`)}
                            />
                        ):''}
                    </div>
                    <div className="flex justify-between">
                        <div className="flex items-center">
                            <Typography variant="textheaderSub2DarkGray" component={'div'} className="max-w-[25rem] truncate mr-3">{jobName}</Typography>
                            <Typography variant="text18Light" component={'div'} className="max-w-[18rem] truncate border-0 border-l border-solid border-culturedDark px-3 mr-3">{jobRefId}</Typography>
                            <Chip label={`${jobStatus ? 'Active':'Inactive'}`} className={`${jobStatus ? 'bg-green bg-opacity-20 text-green':'text-red bg-red  bg-opacity-20'} font-semibold rounded-lg`}/>

                        </div>
                        <div className="flex items-center">
                            <div className="mr-5 flex items-center">
                                <Typography variant="text18" component={'div'} className="mr-3 font-medium">
                                    Email Automation
                                </Typography>
                                <div>
                                    <SwitchInput
                                        checked={autoEmail}
                                        setChecked={(autoEmailStatus) => autoEmailHandle(autoEmailStatus)}
                                    />
                                </div>
                            </div>
                            <Tabs onChange={handleChange} value={value}>
                                <Tab label="Pending" value={0} />
                                <Tab label="Shortlisted" value={1} />
                                <Tab label="Rejected" value={2} />
                            </Tabs>
                        </div>
                    </div>
                    
                    <div className='rounded-xl rounded-tr-none mb-5 bg-white p-5 pt-1 border border-solid border-cultured'>
                        <SimpleBar 
                            className={`${selectCheckbox.length > 0 ? 'review-selected':'review-unselected'} rounded-xl p-0 m-0`}
                            onScrollCapture={handleScroll}
                        >
                        {cvList?.pages?.[0]?.content?.length > 0 ? (
                            
                                <div className='table-review'>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="max-w-[3rem]">
                                                    <Checkbox 
                                                        id="selectAll"
                                                        checkedIcon={<img src={Check} alt="View icon" className="w-[1.5rem]" />}
                                                        icon={<img src={Uncheck} alt="View icon" className="w-[1.5rem]" />}
                                                        onChange={(e)=>isCheckedAll(e.target.checked)}
                                                        checked={selectAll}
                                                        disabled={cvProcess}
                                                        className={`${cvProcess ? 'opacity-20':''} py-2`}
                                                    />
                                                </TableCell>
                                                <TableCell>CV</TableCell>
                                                <TableCell>Applicant</TableCell>
                                                <TableCell>Upload Date</TableCell>
                                                <TableCell>Match Rating (%)</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {cvList.pages.map((page, pageIndex) => (
                                            page.content.map((cv, index) => (
                                                <TableRow
                                                    key={pageIndex+index}
                                                >
                                                    <TableCell className="max-w-[3rem]">
                                                        <Checkbox 
                                                            checkedIcon={<img src={Check} alt="View icon" className="w-[1.5rem]" />}
                                                            icon={<img src={Uncheck} alt="View icon" className="w-[1.5rem]" />}
                                                            onChange={(e)=>{isChecked(e.target.checked, cv.id, cv.status)}}
                                                            id={`checkbox-${cv.id}`}
                                                            checked={selectCheckbox.includes(cv.id)}
                                                            disabled={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed' ? true : false}
                                                            className={cv.status === 'Processing' || cv.status === 'Uploading'  || cv.status === 'Failed' ? 'opacity-20':''}
                                                        />
                                                    </TableCell>
                                                    <TableCell className="max-w-[10vw] truncate">
                                                        {cv.fileName}
                                                    </TableCell>
                                                    <TableCell className="max-w-[15vw] truncate capitalize">
                                                        {cv.candidate ? cv.candidate.name : 'N/A'}
                                                    </TableCell>
                                                    <TableCell >{cv.uploadedDate? covertTimestamp(cv.uploadedDate) : 'N/A'}</TableCell>
                                                    <TableCell >{cv.rating ? cv.rating : 'N/A'}</TableCell>
                                                    <TableCell >
                                                        <Status status={cv.status}/>
                                                    </TableCell>
                                                    <TableCell className={`${value === 2 ? 'w-[21rem]': value === 1 ? 'w-[19rem]' : 'w-[22rem]'}`}>
                                                        <Tooltip title="Summary">
                                                            <IconButton 
                                                                aria-label="summary" 
                                                                disabled={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed'? true : false}
                                                                className={cv.status === 'Processing'|| cv.status === 'Uploading' || cv.status === 'Failed'? 'opacity-20 mr-2':'mr-2'}
                                                                onClick={()=>summary(cv.reason, cv.candidate, cv.rating, cv.ratingBreakdown)}
                                                            >
                                                                <img src={Description} alt="message icon" className="w-[1.5rem]" />
                                                            </IconButton>
                                                        </Tooltip> 
                                                        <Tooltip title="View CV">
                                                            <IconButton aria-label="View CV" className="mr-2" onClick={()=>viewResume(cv.cvPdfUrl)}>
                                                                <img src={View} alt="View icon" className="w-[1.5rem]" />
                                                            </IconButton>
                                                        </Tooltip> 
                                                        {value === 2 ? (
                                                            <Tooltip title="Reject Reason Preview">
                                                                <IconButton aria-label="Reject reseason preview" 
                                                                 onClick={()=>reasonPreview(cv.id, cv.candidate.name, cv.rating, cv.cvRejectedReason)}
                                                                disabled={Boolean(!cv.cvRejectedReason)}
                                                                className={`${Boolean(cv.cvRejectedReason) ? '' : 'opacity-20' }  mr-2`}
                                                                >
                                                                    <img src={InforIcon} alt="info icon" className="w-[1.5rem]" />
                                                                </IconButton>
                                                            </Tooltip> 
                                                        ):''}
                                                        {value === 0 ? (
                                                        <>
                                                            <Tooltip title={autoEmail ? "Approve & Reply" : "Approve"}>
                                                                <IconButton 
                                                                    aria-label="Approve" 
                                                                    onClick={() => shortlistSingle(cv.id)}
                                                                    disabled={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed'? true : false}
                                                                    className={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed'? 'opacity-20 mr-2':'mr-2'}
                                                                >
                                                                    <img src={autoEmail ? emailShortlist : TickCircle} alt="Approve icon" className={autoEmailEnable ? "w-[1.6rem]" : "w-[1.5rem]"} />
                                                                </IconButton>
                                                            </Tooltip> 
                                                            <Tooltip title={autoEmail ? "Reject & Reply" : "Reject"}>
                                                                <IconButton 
                                                                    aria-label="Rejected"
                                                                    onClick={() => openReject(cv.id, cv.candidate.name, cv.rating)}
                                                                    disabled={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed' ? true : false}
                                                                    className={cv.status === 'Processing' || cv.status === 'Uploading' || cv.status === 'Failed' ? 'opacity-20 mr-2':'mr-2'}
                                                                >
                                                                    <img src={autoEmail ? emailReject : CloseCircle} alt="Rejected icon" className={autoEmailEnable ? "w-[1.6rem]" : "w-[1.5rem]"} />
                                                                </IconButton>
                                                            </Tooltip> 
                                                        </>
                                                        ):''}
                                                        {
                                                            (value === 1 || value === 2) && autoEmail ? (
                                                                <Tooltip title={autoEmail ? (cv.mailSentStatus ? "Replied" : "Reply") : ""}>
                                                                    <IconButton 
                                                                        aria-label="Rejected"
                                                                        onClick={() => !cv.mailSentStatus && pendingEmail(cv.id)}
                                                                        disabled={cv.status === 'Processing' || cv.status === 'Uploading'|| cv.status === 'Failed' ? true : false}
                                                                        className={`mr-2 ${cv.mailSentStatus ? 'cursor-default' : 'cursor-pointer' }` }
                                                                    >
                                                                        <img src={autoEmail ? (cv.mailSentStatus ? EmailSent : emailPending) : ''} alt="Rejected icon" className={autoEmail && !cv.mailSentStatus? "w-[1.6rem]" : "w-[1.5rem]" } />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ):''
                                                        }
                                                        <Tooltip title="Download">
                                                            <IconButton aria-label="Download" className="mr-2" onClick={()=>downloadSingle(cv.id, cv.fileName)}>
                                                                <img src={Import} alt="Download icon" className="w-[1.5rem]" />
                                                            </IconButton>
                                                        </Tooltip> 
                                                        <Tooltip title="Delete">
                                                            <IconButton aria-label="delete" className="mr-2" onClick={()=>{setOpenDelete(true); setDelType(1); setDeleteId(cv.id)}}>
                                                                <img src={TrashDark} alt="delete icon" className="w-[1.5rem]" />
                                                            </IconButton>
                                                        </Tooltip> 
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            
                            ):(

                                loader ? (
                                    <div className="w-full flex-col flex justify-center items-center review-unselected">
                                        <img src={LoaderIcon} alt="loading" className="w-[4rem] mb-5"/>
                                        <Typography variant="textheader3" component={'div'}>Loading...</Typography>
                                    </div>
                                ):(
                                    <div className="w-full flex-col flex justify-center items-center review-unselected">
                                        <img src={NotFound} alt="not found" className="w-[25%] mb-5"/>
                                        <Typography variant="textheader3" component={'div'}>CVs Not Found!</Typography>
                                    </div>
                                )
                                
                            )}
                            {isFetchingNextPage && (
                                <div className="w-full flex-col flex justify-center items-center mt-4">
                                    <img src={LoaderIcon} alt="loading" className="w-[2rem]" />
                                </div>
                            )}
                        </SimpleBar>
                    </div>
                    {selectCheckbox.length > 0 ?( 
                        <FooterBarReveiw
                            shortlist={shortlist}
                            reject={reject}
                            btnFill={'Upload'}
                            buttonRightDel={files.length < 1 ? 'Delete All':''}
                            delAll={delAll}
                            download={download}
                            selectedCount={selectCheckbox.length}
                            tab={value}
                            autoEmailEnable={autoEmail}
                        /> 
                    ):''}
                </div>
            </Container>
        </ThemeProvider>
        
    )
}

export default Review;